<template>
  <div class="add-search-campaign">
    <ChooseCampaignOption
      v-loading="isLoading"
      class="add-search-campaign__box"
      :title="$t('ADVERTISEMENT.CHOOSE_CAMPAIGN.SEARCH_ADS')"
      :description="$t('ADVERTISEMENT.CHOOSE_CAMPAIGN.SEARCH_ADS_DESCRIPTION')"
      :button-text="$t('ADVERTISEMENT.NEW_CAMPAIGN_SEARCH_ADS')"
      :image="require('@/assets/images/campaigns/search-ads.svg')"
      @select="fetchRequirementsAndOpenModal"
    />
    <AddSearchCampaignModal
      v-model="showAddSearchCampaignModal"
      :apps="apps"
      :campaigns="searchAdsCampaigns"
      @add="emitAdd"
    />
  </div>
</template>

<script>
import { Apps, SearchAdsCampaigns } from '@/api/api';
import { AD_NEW_CAMPAIGN_BUTTON_CLICK } from '@/constants/gtm-events';
import ChooseCampaignOption from '../common/ChooseCampaignOption';
import AddSearchCampaignModal from './AddSearchCampaignModal';
import permissions from '@/mixins/permissions';

export default {
  name: 'AddSearchCamapaign',
  components: {
    ChooseCampaignOption,
    AddSearchCampaignModal,
  },
  mixins: [permissions],
  data() {
    return {
      showAddSearchCampaignModal: false,
      searchAdsCampaigns: [],
      apps: [],
      isLoading: false,
    };
  },
  methods: {
    emitAdd() {
      this.$emit('add');
    },
    fetchRequirementsAndOpenModal() {
      this.$gtm.trackEvent(AD_NEW_CAMPAIGN_BUTTON_CLICK);

      this.isLoading = true;

      const promises = [this.getCampaigns(), this.getApps()];

      return Promise.all(promises)
        .then(() => {
          this.showAddSearchCampaignModal = true;
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    getApps() {
      if (this.apps.length) return Promise.resolve();

      return Apps.getList()
        .then(apps =>
          apps.filter(
            app =>
              this.hasAdvertisement(app.packageName) && app.published === 'P',
          ),
        )
        .then(apps => {
          this.apps = apps;
        })
        .catch(({ message }) => {
          this.$message.error(message);
          throw new Error(message);
        });
    },
    getCampaigns() {
      return SearchAdsCampaigns.getCampaigns()
        .then(campaigns => {
          this.searchAdsCampaigns = campaigns;
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
          throw new Error(message);
        });
    },
  },
};
</script>

<style lang="scss">
.add-search-campaign {
  &__box {
    height: 100%;
  }
}
</style>
